'use client';

import Box from '@mui/material/Box';
import { GRUND, hexTillRgba, ljus, type Kombonamn } from 'src/components/rörelse';

/**
 * Markerar en scen som beskriver planerad funktionalitet.
 *
 * Presentationerna visar vad produkten är tänkt att göra, inte en inventering av vad som
 * råkar vara påkopplat i dag. Markeringen är därför en diskret upplysning om var i
 * ordningen något ligger — inte en brasklapp som tar udden av scenen den sitter i.
 *
 * Ett beslut fattat en gång, i en komponent, och tillämpat likadant överallt.
 */
export function VisionsMarkering({ kombo, text = 'Planerad funktion' }: { kombo: Kombonamn; text?: string }) {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 0.6,
                borderRadius: 999,
                border: `1px dashed ${hexTillRgba(ljus(kombo), 0.65)}`,
                color: GRUND.dämpad,
                fontSize: 12.5,
                letterSpacing: '0.02em'
            }}
        >
            <Box
                aria-hidden
                sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: ljus(kombo), opacity: 0.8 }}
            />
            {text}
        </Box>
    );
}
